import { ATTRIBUTION_PRODUCT_TYPES, MIDMARKET_TIERS } from './consts';

export const parseInviteParams = searchParams => {
    const get = key => searchParams.get(key) || '';

    const sfdc = get('sfdc');
    const productType = get('product_type');
    // account_tier_override wins over account_tier.
    const accountTier = get('account_tier_override') || get('account_tier');

    return {
        sfdc,
        // The form only renders when a real SFDC account id is present (length > 1).
        hasSfdc: sfdc.length > 1,
        enableAttribution: ATTRIBUTION_PRODUCT_TYPES.includes(productType),
        isMidmarket: MIDMARKET_TIERS.includes(accountTier),
        company: get('company'),
        domains: get('domains'),
    };
};

export const resolveOrgGroup = (orgGroups, { enableAttribution, tier }) => {
    if (!orgGroups || !tier) {
        return null;
    }
    return orgGroups.find(group => group.enable_attribution === enableAttribution && group.tier.includes(tier)) || null;
};

export const collectEnabledFeatureFlags = (featureFlagsSelected = {}) =>
    Object.keys(featureFlagsSelected).filter(flag => featureFlagsSelected[flag] === true);
